import CarouselCardsV2 from "./CarouselCardsV2";
export default CarouselCardsV2;
